import React, { type ReactNode } from 'react'
import { Card, Text, Box } from '@mantine/core'

export interface StatCardProps {
  label: string;
  value: number | string;
  delta?: number;
  icon?: ReactNode;
  color?: string;
}

export default function StatCard ({ label, value, delta, icon, color }: StatCardProps) {
  return (
    <Card
      shadow="sm"
      padding="md"
      radius="md"
      withBorder
      sx={{ width: 160, minWidth: 160, position: 'relative' }}
    >
      {icon && (
        <Box sx={{ position: 'absolute', top: 12, right: 12, opacity: 0.7 }}>
          {icon}
        </Box>
      )}
      <Text size="xl" weight={700} color={color ?? 'dark'}>
        {value}
      </Text>
      {delta !== undefined && delta !== null && (
        <Text
          size="sm"
          color={delta >= 0 ? 'green' : 'red'}
          weight={500}
          mt={4}
        >
          {delta >= 0 ? '▲' : '▼'} {delta >= 0 ? `+${delta}` : delta}
        </Text>
      )}
      <Text size="sm" color="dimmed" mt="xs">
        {label}
      </Text>
    </Card>
  )
}
